import React, { PropTypes } from 'react';
import classnames from 'classnames';
import './EmptyDataPlaceholder.scss';

class EmptyDataPlaceholder extends React.Component {
  constructor(props) {
    super(props);
  }
  
  render() {
    const { title, icon } = this.props;
    return (
      <div className='placeholder'>
        <div>
          <i className={classnames(icon, 'icon')}></i>
        </div>
        <div className='placeholder-title'>{title}</div>
      </div>
    )
  }
}

export default EmptyDataPlaceholder;



// WEBPACK FOOTER //
// ./src/components/UI/EmptyDataPlaceholder/index.js